<template>
  <div class="falcon-chart" ref="chart">

  </div>
</template>

<script>
import Chart from 'chart.js';
import {CHART_COLORS, CHART_COLORS_ARRAY, FONT_FAMILY} from "./chartColors";
import echarts from 'echarts';

export default {
  name: 'shareholdersGraph',
  data() {
    let data = this.data, processedData = [];
    data.sort(function (a, b) {
      return b.percentage - a.percentage;
    });

    let otherData = {
      "name": "Other shareholders",
      "percentage": 0
    };

    for (let i = 0; i < data.length; i++) {
      if (i <= 2) {
        processedData.push(data[i]);
      } else {
        otherData.percentage += data[i].percentage;
      }
    }

    if (data.length > 3) {
      processedData.push(otherData);
    }


    return {
      graphData: processedData.map(function (shareholder, index) {
        return {
          value: shareholder.percentage,
          name: shareholder.name,
          itemStyle: {
            color: CHART_COLORS_ARRAY[index]
          }
        }
      }),

      labels: processedData.map(function (shareholder) {
        return shareholder.name;
      }),

    }
  },
  props: ['data'],
  mounted() {

    let option = {
      tooltip: {
        trigger: 'item',
        formatter: `{b}: {d}%`
      },
      textStyle: {
        fontFamily: FONT_FAMILY
      },
      legend: {
        orient: 'vertical',
        left: 10,
        top: 280,
        // top: this.labels.length <= 2? 35: -15,
        borderRadius: [0, 0, 0, 0],
        icon: 'circle',
        padding: [0, 0, 30, 0],
        data: this.labels,
        formatter: name => {
          var series = myChart.getOption().series[0];
          var value = series.data.filter(row => row.name === name)[0].value
          return `${name} ${value}%`;
        },
      },
      series: [
        {
          top: -75,
          name: '',
          type: 'pie',
          radius: ['55%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },

          labelLine: {
            show: false
          },
          data: this.graphData,
        }
      ]
    };

    var myChart = echarts.init(this.$refs['chart'], null, {
      renderer: 'svg'
    });
    myChart.setOption(option);

  },
  methods: {},
  computed: {},
}
</script>

<style lang="scss" scoped>

.falcon-chart {
  //position: relative;
  //top: -39px;
  background-image: url(../../../images/shareholder_chart_icon.png);
 background-repeat: no-repeat;
  background-position: 51% 37%;
  background-size: 72px;
  width: 100%;
  height: 364px;
}
</style>
